import { InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import React from 'react'
import styled from 'styled-components/macro'

/**
 * Label + info icon tip for Catch Board headers and status copy.
 */
const CatchBoardTipLabel = ({
  label,
  tip,
  iconOnly = false,
  testId,
  ...rest
}) => {
  if (!tip) {
    return iconOnly ? null : (
      <span data-testid={testId} {...rest}>
        {label}
      </span>
    )
  }

  return (
    <Wrap data-testid={testId} {...rest}>
      {iconOnly ? null : <span>{label}</span>}
      <Tooltip title={tip}>
        <InfoIcon aria-label={typeof tip === 'string' ? tip : 'More info'} />
      </Tooltip>
    </Wrap>
  )
}

const Wrap = styled.span`
  align-items: center;
  display: inline-flex;
  gap: 4px;
`

const InfoIcon = styled(InfoCircleOutlined)`
  color: ${({ theme }) => theme.colours.oliveGrey || '#888'};
  font-size: 12px;
`

export default CatchBoardTipLabel
